import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { mappedHttpErrorResponseOperator } from '@adnova/jf-ng-components';

import { AnnouncementAdminService, ProblemDTO } from '../../openapi/shell-service-openapi';
import { AnnouncementDetailEntitiesActions } from './announcement-detail-entities.actions';

/**
 * Effects für Announcement-Detail-Entities.
 *
 * Handhabt HTTP-Requests für Announcement-Details.
 */
@Injectable()
export class AnnouncementDetailEntitiesEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(AnnouncementAdminService);
  private readonly logger = inject(NGXLogger);

  /**
   * Lädt die Detail-Daten eines Announcements.
   */
  readonly loadDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnnouncementDetailEntitiesActions.loadDetail),
      switchMap(({ id }) =>
        this.service.readAnnouncement(id).pipe(
          map((detail) =>
            AnnouncementDetailEntitiesActions.loadDetailSuccess({ detail }),
          ),
          catchError((error) => of(error).pipe(
            mappedHttpErrorResponseOperator<ProblemDTO>(error),
            map((mappedError) => {
              this.logger.error('Fehler beim Laden der Announcement-Details.', mappedError);
              return AnnouncementDetailEntitiesActions.loadDetailFailure({ error: mappedError });
            }),
          )),
        ),
      ),
    ),
  );
}
